module.exports = __webpack_public_path__ + "media/GameStart.daf45894.mp3";